import { FlaskRound, History, Map } from "lucide-react";
import { ActionButtonConfig } from "./types";

// Button configuration array - Open/Closed Principle (easy to extend)
export const ACTION_BUTTONS: ActionButtonConfig[] = [
  {
    id: 8,
    label: "Product Mapping",
    icon: Map,
    variant: "default"
  },
  {
    id: 9,
    label: "Product Simulation - Beta",
    icon: FlaskRound,
    variant: "outline"
  },
  {
    id: 11,
    label: "Product History",
    icon: History,
    variant: "outline"
  }
];
